import { render, staticRenderFns } from "./CardTarjaMesacast.vue?vue&type=template&id=a21b3c1c&scoped=true"
import script from "./CardTarjaMesacast.vue?vue&type=script&lang=js"
export * from "./CardTarjaMesacast.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaMesacast.vue?vue&type=style&index=0&id=a21b3c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21b3c1c",
  null
  
)

export default component.exports